// extracted by mini-css-extract-plugin
export default {"root":"MouseWrapper-module_root-DG8gU"};